import { render, staticRenderFns } from "./weihu.vue?vue&type=template&id=6bf4952c&scoped=true&"
var script = {}
import style0 from "./weihu.vue?vue&type=style&index=0&id=6bf4952c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4952c",
  null
  
)

export default component.exports